import React, { useEffect, useState, useRef, useCallback } from "react";
import {
  Col,
  Row,
  Button,
  InputGroup,
  img,
  OverlayTrigger,
  Tooltip,
  Image,
} from "react-bootstrap";
import Form from "react-bootstrap/Form";
import { Link, useNavigate, useParams } from "react-router-dom";
import iicon from "../../assets/i.svg";
// Require Editor JS files.
import "froala-editor/js/froala_editor.pkgd.min.js";
import "froala-editor/js/plugins.pkgd.min.js";
// Require Editor CSS files.
import "froala-editor/css/froala_style.min.css";
import "froala-editor/css/froala_editor.pkgd.min.css";

import FroalaEditor from "react-froala-wysiwyg";
import Loader from "../Loader/Loader";
import SideBar from "../SideBar/SideBar";
import TabsSection from "../Tabs/TabsSection";
import { MdKeyboardArrowLeft } from "react-icons/md";
import { RegEx } from "../../Utils/RegEx";
import { SavePages } from "../API/MarketPlaceSetUp/SavePages";
import AddImage from "../../assets/AddImage.svg";
import swal from "sweetalert";
import { GetPageUrl } from "../API/MarketPlaceSetUp/GetPageUrl";
import { GetEditPagesData } from "../API/MarketPlaceSetUp/EditpagesData";
import { SaveEditPages } from "../API/MarketPlaceSetUp/EditPages";

// cropper
import Cropper from "react-easy-crop";
import Modal from "react-bootstrap/Modal";
import Slider from "@material-ui/core/Slider";
import Typography from "@material-ui/core/Typography";
import getCroppedImg from "./cropImage";
import { FroalaTextEditor } from "../FroalaEditor/FroalaTextEditor";
import BackButton from "../BackButton/BackButton";

const EditPage = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  // feild
  const [PageName, setPageName] = useState("");
  const [PageUrl, setPageUrl] = useState("");
  const [PageTitle, setPageTitle] = useState("");
  const [MetaDescription, setMetaDescription] = useState("");
  const [PageContent, setPageContent] = useState("");
  const [image, setImage] = useState(null);
  const inputRef = useRef();
  const [imageType, setimageType] = useState(null);

  // feild--Err
  const [PageNameErr, setPageNameErr] = useState("");
  const [PageUrlErr, setPageUrlErr] = useState("");
  const [imageErr, setImageErr] = useState(null);
  const [PageTitleErr, setPageTitleErr] = useState("");
  const [MetaDescriptionErr, setMetaDescriptionErr] = useState("");
  const [PageContentErr, setPageContentErr] = useState("");
  const { slug } = useParams();

  const [ShowEditBtn, setShowEditBtn] = useState(false);

  useEffect(() => {
    setLoading(true);
    getEditData();
  }, []);

  const cityId = localStorage.getItem("cityId");
  const cityName = localStorage.getItem("cityName");

  const getEditData = async () => {
    const getEditId = slug.split("=");

    const data = {
      page_id: parseInt(getEditId[1]),
      mms_city_id: parseInt(cityId),
      city_name: cityName,
    };
    const Response = await GetEditPagesData(data, () => {
      navigate("/");
    });
    if (Response.success == true) {
      setPageName(Response.data[0].page_name);
      setPageTitle(Response.data[0].page_title);
      setMetaDescription(Response.data[0].description);
      setPageContent(Response.data[0].page_content);
      setPageUrl(Response.data[0].page_internal_url);
      setcropImg(Response.data[0].page_image);
      setTimeout(() => {
        setLoading(false);
      }, 1000);
    } else if (Response.status === 429) {
      setLoading(true);
      swal({
        // title: "Error!",
        title: `${Response.message}`,
        icon: "error",
        buttons: "OK",
      });
    } else {
      setLoading(false);
      swal({
        text: `${Response.message}`,
        icon: "warning",
        buttons: "Ok",
        dangerMode: false,
      });
    }
  };

  const onChangeHandler = async (fieldName, value) => {
    if (fieldName === "PageName") {
      setPageName(value);
      const str = value.split(" ").join("");

      if (value.length == 0) {
        setPageNameErr("*Please Enter Page Name");
      } else if (str.length > 15) {
        setPageNameErr("*Character limit exceeded!");
      } else {
        setPageNameErr("");
      }

      if (value.length != 0) {
        const cityId = localStorage.getItem("cityId");
        const cityName = localStorage.getItem("cityName");
        const pageNameText = value.toLowerCase().replace(/ +/g, "");
        const cityNameText = cityName.toLowerCase().replace(/ +/g, "");
        const getEditId = slug.split("=");
        const data = {
          mms_city_id: parseInt(cityId),
          page_name: value,
          city_name: cityName,
          page_id: parseInt(getEditId[1]) ?? "",
        };
        const response = await GetPageUrl(data, () => {
          navigate("/");
        });
        console.log(response);
        if (response.success == true) {
          setLoading(false);
          setPageUrl(response.data);
        } else if (response.status === 429) {
          setLoading(true);
          swal({
            // title: "Error!",
            title: `${response.message}`,
            icon: "error",
            buttons: "OK",
          });
        } else {
          swal({
            text: `${response.message}`,
            icon: "warning",
            buttons: "OK",
            dangerMode: false,
          });
        }
      }
    }
    // else if (fieldName === "PageUrl") {
    //   setPageUrl(value);
    //   let re = RegEx.url;
    //   if (!re.test(value)) {
    //     setPageUrlErr("* Please Enter Valid Page Url");
    //   } else {
    //     setPageUrlErr("");
    //   }
    // }
    else if (fieldName === "PageTitle") {
      setPageTitle(value);
      if (value.length == 0) {
        setPageTitleErr("* Please Enter Page Title");
      } else {
        setPageTitleErr("");
      }
    } else if (fieldName === "MetaDescription") {
      setMetaDescription(value);
      if (value.length == 0) {
        setMetaDescriptionErr("* Please Enter Meta Description");
      } else {
        setMetaDescriptionErr("");
      }
    } else if (fieldName === "PageContent") {
      setPageContent(value);
      if (value.length == 0) {
        setPageContentErr("* Please Add Page Content");
      } else {
        setPageContentErr("");
      }
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    if (cropImg == "") {
      setImageErr("* Please Add Logo");
    }
    if (PageName.length === 0) {
      setPageNameErr("* Please Enter Page Name");
    }
    // if (PageUrl.length === 0) {
    //   setPageUrlErr("* Please Enter Page Url");
    // }
    if (PageTitle.length === 0) {
      setPageTitleErr("* Please Enter Page Title");
    }
    if (MetaDescription.length === 0) {
      setMetaDescriptionErr("* Please Enter Meta Description");
    }

    if (
      PageName.length &&
      // PageUrl.length &&
      PageTitle.length &&
      MetaDescription.length != 0
    ) {
      const Cropped = cropImg.split("/");
      // process.env.REACT_APP_COMMON_URL + "market_place_data/nagivation_pages/page_2023-04-04-06-48-37_2.jpeg"
      const ImagePath = Cropped[3] + "/" + Cropped[4] + "/" + Cropped[5];
      const getEditId = slug.split("=");
      const data = {
        mms_city_id: parseInt(cityId),
        city_name: cityName,
        page_option: "internal",
        page_name: PageName,
        internal_url: PageUrl,
        page_title: PageTitle,
        external_url: "",
        meta_description: MetaDescription,
        page_content: PageContent,
        page_image:
          iscropImgEdited == false
            ? ImagePath
            : { data: cropImg, file_type: "png" },
        page_id: [parseInt(getEditId[1])],
        image_change: iscropImgEdited == false ? 0 : 1,
      };
      const Response = await SaveEditPages(data, () => {
        navigate("/");
      });
      if (Response.status === 429) {
        setLoading(true);
        swal({
          text: `${Response.message}`,
          icon: "warning",
          buttons: "Ok",
          dangerMode: false,
        });
      } else if (Response.success == false) {
        setLoading(false);
        swal({
          text: `${Response.message}`,
          icon: "warning",
          buttons: "Ok",
          dangerMode: false,
        }).then((success) => {
          if (success) {
            navigate("/marketplace-setup/pages");
          }
        });
      } else {
        setLoading(false);
        swal({
          // title: "Success!",
          title: `${Response.message}`,
          icon: "success",
          buttons: "Ok",
          dangerMode: false,
        }).then((success) => {
          if (success) {
            navigate("/marketplace-setup/pages");
          }
        });
      }
    }
  };

  // cropper

  const [show, setShow] = useState(false);
  const [ShowBrowseLogo, setShowBrowseLogo] = useState(false);
  // img
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [rotation, setRotation] = useState(0);
  const [zoom, setZoom] = useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);

  const [cropImg, setcropImg] = useState("");
  const [prevImg, setPrevimg] = useState("");
  const [iscropImgEdited, setIscropImgEdited] = useState(false);

  const triggerFileSelectPopup = () => inputRef.current.click();

  const onCropComplete = useCallback((croppedArea, croppedAreaPixels) => {
    setCroppedAreaPixels(croppedAreaPixels);
  }, []);

  //  save
  const handleSetCropperImg = (e) => {
    const fsize = e.target.files[0].size;
    const file = Math.round(fsize / 1024);
    if (!e.target.files[0].name.match(/\.(jpg|jpeg|png|gif|jfif)$/)) {
      setShow(false);
      setPrevimg("");
      swal({
        title: "Error!",
        text: "Please select a valid image",
        icon: "error",
        button: "Ok",
      });
    } else if (fsize >= 1000000) {
      swal({
        title: "Error!",
        text: "File too Big, please select a file less than 1MB",
        icon: "error",
        button: "Ok",
      });
    } else {
      setShow(true);
      setPrevimg(URL.createObjectURL(e.target.files[0]));
      console.log("banner img", e.target.files);
    }
  };

  const showCroppedImage = useCallback(async () => {
    try {
      const croppedImage = await getCroppedImg(
        prevImg,
        croppedAreaPixels,
        rotation
      );
      // console.log("done", croppedImage);
      setcropImg(croppedImage);
      setIscropImgEdited(true);
      setShow(false);
      setZoom(1);
      setRotation(0);
      const imgType = croppedImage.split(";");
      const imgTypeData = imgType[0].split("/");
      setimageType(imgTypeData[1]);
    } catch (e) {
      console.error(e);
    }
  }, [croppedAreaPixels, rotation]);

  // editor
  const handleModelChange = (model) => {
    setPageContent(model);
  };

  // Image Upload froala
  const handleImageUpload = (e, editor, response) => {
    const imgSrc = response.link;

    // Insert the uploaded image into the editor
    editor.image.insert(imgSrc, false, null, editor.image.get(), null);

    // Update the editor content
    setPageContent(editor.html.get());
  };
  //

  return (
    <>
      {loading ? <Loader /> : ""}

      {/* cropper */}
      <Modal show={show} onHide={() => setShow(false)} style={{ marginTop: 0 }}>
        <Modal.Header></Modal.Header>
        <Modal.Body style={{ width: "100%", height: 350 }}>
          <div>
            <Cropper
              image={prevImg}
              crop={crop}
              rotation={rotation}
              zoom={zoom}
              aspect={3.33 / 1}
              // cropShape="square"
              showGrid={true}
              onCropChange={setCrop}
              onRotationChange={setRotation}
              onCropComplete={onCropComplete}
              onZoomChange={setZoom}
            />
          </div>
        </Modal.Body>
        <Modal.Footer className="modelFooter">
          {/* <div className="controls">
     <div className="sliderContainer">
       <Typography variant="overline" className="sliderLabel">
         Zoom
       </Typography>
       <Slider
         value={zoom}
         min={1}
         max={3}
         step={0.1}
         aria-labelledby="Zoom"
         className="slider"
         onChange={(e, zoom) => setZoom(zoom)}
       />
     </div>
     <div className="sliderContainer">
       <Typography variant="overline" className="sliderLabel">
         Rotation
       </Typography>
       <Slider
         value={rotation}
         min={0}
         max={360}
         step={1}
         aria-labelledby="Rotation"
         className="slider"
         onChange={(e, rotation) => setRotation(rotation)}
       />
     </div>
   </div> */}
          <button className="close_btn_cropper" onClick={() => setShow(false)}>
            Cancel
          </button>
          <button
            className="green-btn mt-0 btn btn-primary"
            onClick={showCroppedImage}
          >
            Save
          </button>
        </Modal.Footer>
      </Modal>

      <div className="gray-bg">
        <div className="navbar-section p-0">
          <SideBar />
        </div>
        <div className="main-content pt-5 pr-3 pb-4">
          <BackButton />
          <p className="page-maintitle">Pages</p>
          <div className="acc-dashboard mt-4 Marketplace">
            <TabsSection />

            <div>
              <p class="page-maintitle pt-2">Edit Page</p>
              <p class="page-subtitle"></p>
            </div>
            {/* start */}
            <Row>
              {/* <Col md="2"></Col> */}
              <Col md="10" style={{ marginLeft: "auto", marginRight: "auto" }}>
                <div
                  //   onSubmit={SaveHandler}
                  className="formmain mx-5 mt-4 signin-row profile-form pb-4"
                >
                  <Row>
                    <Col md="6" className="" style={{ marginTop: 14 }}>
                      <Form.Group className="mb-4" controlId="formBasicEmail">
                        <Form.Label className="form-label-custom">
                          Page Name{" "}
                          <span className="star-required">
                            *
                            {["top"].map((placement) => (
                              <OverlayTrigger
                                key={placement}
                                placement={placement}
                                overlay={
                                  <Tooltip
                                    id={`tooltip-${placement}`}
                                    className="Tooltips"
                                    style={{ opacity: "1" }}
                                  >
                                    Maximum characters allowed: 20
                                  </Tooltip>
                                }
                              >
                                <Image
                                  src={iicon}
                                  className="pt-1 TTip"
                                  width="20px"
                                ></Image>
                              </OverlayTrigger>
                            ))}
                          </span>
                        </Form.Label>

                        <InputGroup className="edit-border">
                          <Form.Control
                            autoComplete="off"
                            type="text"
                            placeholder="Enter Page Name"
                            className="custom-formcontrol"
                            value={PageName}
                            maxLength={20}
                            onChange={(e) => {
                              onChangeHandler("PageName", e.target.value);
                            }}
                            // maxLength={10}
                          />
                        </InputGroup>
                        {PageNameErr && (
                          <p className="text-danger">{PageNameErr}</p>
                        )}
                        {/* // */}
                      </Form.Group>
                    </Col>
                    {/* <Col md="6" className="">
                      <Form.Group className="mb-4" controlId="formBasicEmail">
                        <Form.Label className="form-label-custom">
                          Page URL{" "}
                          <span className="info-text">
                            &#40;Auto generated&#41;
                          </span>
                        </Form.Label>

                        <InputGroup className="edit-border">
                          <Form.Control
                            autoComplete="off"
                            type="text"
                            placeholder="Enter Page URL"
                            className="custom-formcontrol"
                            value={PageUrl}
                            maxLength={100}
                            // onChange={(e) => {
                            //   onChangeHandler("PageUrl", e.target.value);
                            // }}
                          />
                        </InputGroup>
                        {PageUrlErr && (
                          <p className="text-danger">{PageUrlErr}</p>
                        )}
                      </Form.Group>
                    </Col> */}
                    <Col md="6" className="">
                      <Form.Group className="mb-4" controlId="formBasicEmail">
                        <Form.Label className="form-label-custom">
                          <div>
                            Page Title <span className="star-required">*</span>
                            <p className="info-text-space">
                              &#40;"Appears in the browser tab",Maximum
                              characters allowed: 60&#41;
                            </p>
                          </div>
                        </Form.Label>

                        <InputGroup className="edit-border">
                          <Form.Control
                            autoComplete="off"
                            type="text"
                            placeholder="Enter Page Title"
                            className="custom-formcontrol"
                            value={PageTitle}
                            maxLength={60}
                            onChange={(e) => {
                              onChangeHandler("PageTitle", e.target.value);
                            }}
                          />
                        </InputGroup>
                        {PageTitleErr && (
                          <p className="text-danger">{PageTitleErr}</p>
                        )}
                      </Form.Group>
                    </Col>
                    <Col md="12" className="">
                      <Form.Group className="mb-4" controlId="formBasicEmail">
                        <Form.Label className="form-label-custom">
                          <div>
                            Meta description{" "}
                            <span className="star-required">*</span>
                            <p className="info-text-space">
                              &#40;Maximum characters allowed: 160&#41;
                            </p>
                          </div>
                        </Form.Label>

                        <InputGroup className="edit-border">
                          <Form.Control
                            autoComplete="off"
                            type="text"
                            placeholder="Enter Meta Description"
                            className="custom-formcontrol"
                            value={MetaDescription}
                            maxLength={160}
                            onChange={(e) => {
                              onChangeHandler(
                                "MetaDescription",
                                e.target.value
                              );
                            }}
                          />
                        </InputGroup>
                        {MetaDescriptionErr && (
                          <p className="text-danger">{MetaDescriptionErr}</p>
                        )}
                      </Form.Group>
                    </Col>

                    <Col md="12" className="">
                      <Form.Group className="mb-0" controlId="formBasicEmail">
                        <Form.Label className="form-label-custom">
                          Page Banner <span className="star-required">*</span>
                        </Form.Label>

                        <div
                          className="upload_main_banner"
                          onClick={triggerFileSelectPopup}
                        >
                          <input
                            type="file"
                            accept="image/*"
                            ref={inputRef}
                            style={{ display: "none" }}
                            onChange={handleSetCropperImg}
                            onClick={(e) => (e.target.value = null)}
                          />
                          {cropImg == "" ? (
                            <>
                              <div
                                className="page_img"
                                style={{ padding: image == null ? 20 : 0 }}
                              >
                                <img src={AddImage} />
                                <p className="size_p">1500 X 450 Px</p>{" "}
                                <button className="check-green-btn2 btn btn-primary">
                                  + Add Picture
                                </button>
                              </div>
                            </>
                          ) : (
                            <div
                              className="edit_hover_main"
                              onMouseEnter={() => setShowEditBtn(true)}
                              onMouseLeave={() => setShowEditBtn(false)}
                            >
                              <img src={cropImg} className="BannerImgStore" />

                              {ShowEditBtn && (
                                <button
                                  className="green-btn btn btn-primary edit_hover_buttons"
                                  style={{
                                    width: 135,
                                    opacity: 1,
                                    zIndex: 9999,
                                  }}
                                >
                                  Edit Picture
                                </button>
                              )}
                            </div>
                          )}
                        </div>
                      </Form.Group>
                    </Col>

                    <Col md="12" className="mt-4">
                      <Form.Group className="mt-4" controlId="formBasicEmail">
                        <Form.Label className="form-label-custom flex-content">
                          Page Content <span className="star-required">*</span>
                          <p className="info-text-space-f-13">
                            &#40;To start from a new line, please press Shift +
                            Enter.&#41;
                          </p>
                        </Form.Label>
                        <div className="p-3 page_cont">
                          <FroalaTextEditor
                            TemplateContent={PageContent}
                            setTemplateContent={setPageContent}
                          />
                        </div>
                      </Form.Group>
                    </Col>
                  </Row>
                  <div className="text-center small-btns d-flex mt-4">
                    <Link to="/marketplace-setup/pages">
                      <p className="view mt-3">Discard</p>
                    </Link>
                    <Button
                      variant="primary"
                      type="submit"
                      className="green-btn mt-3"
                      onClick={(e) => handleSubmit(e)}
                    >
                      Update
                    </Button>
                  </div>
                </div>
              </Col>
              {/* <Col md="2"></Col> */}
            </Row>
            {/* end */}
          </div>
        </div>
      </div>
    </>
  );
};

export default EditPage;
